<template>
  <BasicModal
    :title="title"
    :isShowModal="isShowModal"
    :canCancel="true"
    @cancel="cancel">
    <div class="card-content">
      <div class="tab-box-form">
        <div class="tab-box-left">
          <p style="text-align: left;"><b>役職名</b></p>
        </div>
        <div class="tab-box-right" style="justify-content: center;">
          <input maxlength="150" style="width: 100%;" class="input is-small" v-model="positionName"/>
        </div>
        <div class="dot-line"></div>
        <div class="tab-box-left">
          <p style="text-align: left;"><b>説明</b></p>
        </div>
        <div class="tab-box-right" style="justify-content: center;">
          <input maxlength="300" style="width: 100%;" class="input is-small" v-model="positionDescription"/>
        </div>
      </div>
    </div>
    <!-- フッターアクション -->
    <div class="footer-box">
      <button class="button" @click="cancel">キャンセル</button>
      <button class="button is-primary" @click="createPosition()" :disabled="!positionName">追加する</button>
    </div>
  </BasicModal>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
export default {
  name: 'ModalCreatePosition',
  componentName: 'ModalCreatePosition',
  components: {
    BasicModal
  },
  props: {
    isShowModal: {
      type: Boolean,
      require: true
    }
  },
  data () {
    return {
      title: '役職の追加',
      positionName: null,
      positionDescription: null,
      parentPosition: null
    }
  },
  watch: {
    isShowModal () {
      if (!this.isShowModal) {
        this.positionName = null
        this.positionDescription = null
        this.parentPosition = null
      }
    }
  },
  methods: {
    cancel () {
      this.$emit('changeModal', false)
    },
    createPosition () {
      this.$emit('createPosition', {
        positionName: this.positionName,
        positionDescription: this.positionDescription,
        parentPosition: this.parentPosition
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.card-body {
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
}
.tab-box-form {
  width: 100%; display: flex; padding: 8px;
  flex-wrap: wrap;
}
.tab-box-left {
  width: 40%; display: flex; justify-content: flex-start; align-items: center;
  border-right: solid 2px #ccc;
}
.tab-box-right {
  width: 60%; font-size: 13px; padding: 10px; justify-content: flex-start; display: flex;
  flex-wrap: wrap;
}
.dot-line {
  height: 10px;
  width: 100%;
  background-image: url('../../../assets/lp/dot.png');
  background-repeat: repeat-x;
  background-size: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Setting/ModalCreatePosition.vue